import React from 'react';
import './stylesheet/servicecard.css';
import { Icon } from '@iconify/react';
import "./stylesheet/mobilesheet/servicecardM.css";
const Servicecard = () => {
  return (
<>

        <div className="main-card-container">

        <div className="card-container-left card-container">
            <div className="outsidecard">
            <div className="card" >
            <div className="neucard">
                {/* neumorphism card */}
                <span><Icon icon="fluent:design-ideas-16-regular" color="#9747ff" /></span>
                <h1>Design</h1>
                <p>
                Design Is  The Most Important Aspect. because the good Design can attract the Viewers Attention which make  easily 
                </p>
            </div>
                <div className="circle" style={{  background:"linear-gradient(180deg, #337EAD 0%, rgba(183, 11, 243, 0.73) 100%)"}}></div>
            </div>
           
            </div>
        </div>
        <div className="card-container-right card-container">
        <div className="outsidecard">
            <div className="card" >
            <div className="neucard">
                {/* neumorphism card */}
                <span><Icon icon="ic:twotone-developer-mode" color="#f24e1e" /></span>
                <h1>Development</h1>
                <p>
                After Designing It is Important To develop the landing page Like design. Development is adding features into site which make your Website more usefull
                </p>
            </div>
                <div className="circle"style={{  background:" linear-gradient(180deg, #337EAD 0%, rgba(11, 160, 243, 0.61) 100%)"}}></div>
            </div>
           
            </div>
            </div>
        </div>
        <div className="main-card-container">

<div className="card-container-left card-container">
    <div className="outsidecard">
    <div className="card" >
    <div className="neucard">
        {/* neumorphism card */}
        <span><Icon icon="icon-park-outline:seo" color="#85b6ff" /></span>
                <h1>SEO</h1>
                <p>
                After development. this time Is For deployment . we will setup your website SEO friendly  during development. which help Boost your Sell
                </p>
    </div>
        <div className="circle" style={{  background:" linear-gradient(180deg, #97AF35 0%, #004E92 100%)"}}></div>
    </div>
   
    </div>
</div>
<div className="card-container-right card-container">
<div className="outsidecard">
    <div className="card" >
    <div className="neucard">
        {/* neumorphism card */}
        <span><Icon icon="carbon:managed-solutions" color="#002253
" /></span>
                <h1>Managed</h1>
                <p>
                For seamless experience of your Customers/clients it is Necessary To be your site keep error free and up to date                </p>
    </div>
        <div className="circle" style={{  background:"linear-gradient(180deg, #337EAD 0%, rgba(32, 219, 96, 0.32) 100%)"}}></div>
    </div>
   
    </div>
    </div>
</div>
</>  )
}

export default Servicecard